import * as STD                       from '@emersya/mpa-std-lib';
// import * as BasketNS                  from '@emersya/mpa-basket-lib';
import CM                             from '@emersya/mpa-components-manager-lib';
import { Field, InputSelect }  from '@emersya/mpa-components-lib';

export interface IStandingCarpetImprintEditorComponentConfiguration extends Field.Configuration {
};

export class StandingCarpetImprintEditorComponent extends Field.Component {
	// private async updateOptions(event : STD.events.Event<any, CM.Component<any, any>>) {
	// 	if (!app.basket || !app.currentProduct || !app.currentProduct.reference) {
	// 		this.component_throwLibraryError('');
	// 	}
	// 	const carpetImprintPart = app.currentProduct.getPart([ 'carpetImprint' ]);
	// 	carpetImprintPart.options.length = 0;
	// 	carpetImprintPart.currentOption = null;
	// 	// TODO : And of course, add current options.
	// 	const inputSelect = this.component_find('@:content.options');
	// 	for (const c of Array.from(inputSelect.component_outerChilds)) {
	// 		await c.component_delete();
	// 	}
	// 	const updatedProduct = app.currentProduct?.sku?.value;
	// 	if (!updatedProduct) {
	// 		throw STD.errors.user('error while loading new sku product from basket');
	// 	}
	// 	const component = app.component_configuration.productsComponents.find(x => x.type ===
	// 		'carpetImprint' &&
	// 		x.products.includes(app.currentProductSKU)
	// 	);

	// 	if (!component) {
	// 		throw STD.errors.user('No component with type carpetImprint');
	// 	}
	// 	const relatedOptions = app.component_configuration.productsOptions.filter(x => x.component ===
	// 		component.SKU &&
	// 		x.products.find(y => y === updatedProduct));
	// 	for (const optionDescriptor of relatedOptions) {
	// 		const tr = STD.translationsManager.languages.reduce<Record<string, string>>((a, c) => {
	// 			a[ c ] = optionDescriptor.SKU;
	// 			return a;
	// 		}, {});
	// 		// const price = optionDescriptor?.price?.[ app.currentCurrency.id ]?.price;
	// 		const SKUSuffix = optionDescriptor.additionalData ? ` (${ optionDescriptor.additionalData.SKU })` : '';
	// 		carpetImprintPart.createOption({
	// 			id :            optionDescriptor.SKU,
	// 			title :         `${ optionDescriptor.SKU } ${ SKUSuffix }`,
	// 			reference :     { value : optionDescriptor.SKU },
	// 			components :    [],
	// 			metaData :      <any> {
	// 				viewerGroups : optionDescriptor.viewerGroups,
	// 				SKU :          optionDescriptor.additionalData?.SKU,
	// 				RGB :          optionDescriptor.additionalData?.RGB
	// 			},
	// 			pricingInfo :   !optionDescriptor.pricingInfo ? null : {
	// 				pricing :                 BasketNS.Pricing.deserialize(<BasketNS.Pricing.FinalPricing.ISerialized & BasketNS.Pricing.BoundPricing.ISerialized> optionDescriptor.pricingInfo.pricing),
	// 				volumeComputationMethod : optionDescriptor.pricingInfo.volumeComputationMethod
	// 			},
	// 			technicalFees : null
	// 			// price :         (<any> price || null),
	// 		});
	// 		const tile = <StandingCarpetTileNS.Component> await inputSelect.component_instantiateOuterChild<StandingCarpetTileNS.Configuration>(
	// 			{
	// 				type :          'standing-carpetImprint-tile',
	// 				id :            optionDescriptor.SKU,
	// 				tree :          this.component_tree,
	// 				slot :          null,
	// 				isSlot :        false,
	// 				declaredSlot :  null,
	// 				configuration : {
	// 					SKU :                    optionDescriptor.SKU,
	// 					component :              optionDescriptor.component,
	// 					'@innerConfigurations' : {
	// 						'image' : <Image.Configuration> {
	// 							'@translations' : {
	// 								'name' : tr
	// 							},
	// 							'URL' :           optionDescriptor.iconURL
	// 						}
	// 					},
	// 					'@translations' :        {
	// 						text : STD.translationsManager.languages.reduce<STD.translationsManager.TranslationMapping>((a, c) => {
	// 							a[ c ] = optionDescriptor.additionalData?.SKU ?
	// 								`${ (<STD.translationsManager.TranslationMapping> optionDescriptor.translations[ '@name' ])[ c ] }${ SKUSuffix }` :
	// 								<string> (<STD.translationsManager.TranslationMapping> optionDescriptor.translations[ '@name' ])[ c ];
	// 							return a;
	// 						}, {})
	// 					}
	// 				}
	// 			}
	// 		);
	// 		await tile.component_initialize();
	// 		await tile.component_start(event);
	// 	}
	// 	return true;
	// };

	async instantiateMenu(event : STD.events.Event<any, CM.Component<any, any>>) {
		const product = app.currentProduct;
		if (!product) {
			this.component_throwLibraryError('');
		}
		const carpetImprintPart = app.currentProduct.getPart([ 'carpetImprint' ]);
		const fieldContent = this.component_find('@:content');
		if (fieldContent.component_outerChilds.length) {
			for (const x of fieldContent.component_outerChilds) {
				await x.component_delete();
			}
			if(carpetImprintPart.currentOption){
				await carpetImprintPart.unuseOption();
			}
		}else if(carpetImprintPart.currentOption){
			await carpetImprintPart.unuseOption();
		}
		if(product.id !== 'business'){
			return;
		}
		if (!fieldContent.component_outerChilds.length) {
			const defaultCarpetImprintColorSKU = app.currentDefaults.carpetImprint;
			const inputSelect = <InputSelect.Component> await fieldContent.component_instantiateOuterChild<InputSelect.Configuration>(
				{
					type :          'input-select',
					id :            'options',
					tree :          this.component_tree,
					slot :          null,
					isSlot :        false,
					declaredSlot :  null,
					configuration : {
						'renderingMode' : 'radio',
						defaultValue :   defaultCarpetImprintColorSKU || null
					}
				}
			);
			const carpetImprintOptionsDescriptors = app.component_configuration.productsOptions.filter(x => x.component === 'carpetImprint');
			if (!carpetImprintOptionsDescriptors) {
				this.component_throwUserError('');
			}
			await app.fillComponentOptions(
				this,
				carpetImprintPart,
				inputSelect,
				carpetImprintOptionsDescriptors,
				'standing-carpetImprint-tile',
				event
			);
			await inputSelect.component_initialize();
			await inputSelect.component_start(event);
			let checkOptions = false;
			const optionsEnabled = app.component_configuration.productsOptions.filter(x => x.component ===
				'carpetImprint' &&
				x.products.includes(product.id));
			const optionsInfos = carpetImprintOptionsDescriptors.filter(x => optionsEnabled.find(y => y.SKU === x.SKU)).map(optionDescriptor => {
				const option = carpetImprintPart.options.find(x => x.id === optionDescriptor.SKU);
				if (!option) {
					this.component_throwLibraryError('');
				}
				return {
					descriptor : optionDescriptor,
					option
				};
			});
			const optionnalOptions = optionsInfos.filter(x => x.option.pricingInfo &&
				!x.option.pricingInfo.pricing.resolve().isNull());
			const titleOptionalOptions = inputSelect.component_DOM.querySelectorAll('h3')[1];
			if(titleOptionalOptions && optionnalOptions.length === 0){
				titleOptionalOptions.style.display = 'none';
			}
			for (const children of inputSelect.component_outerChilds) {
				if (optionsEnabled.find(x => x.SKU === children.id) && children.component_isDisabled) {
					checkOptions = true;
					await children.component_enable();
				} else if (!optionsEnabled.find(x => x.SKU === children.id)) {
					await children.component_disable();
				} else {
					checkOptions = true;
				}
			}
			const fieldHeader = this.component_find('@:header');
			if (checkOptions) {
				await fieldHeader.component_enable();
			} else {
				await fieldHeader.component_disable();
			}
		}


		STD.translationsManager.update(this.component_DOM);
	};

	// async reset(event : STD.events.Event<any, CM.Component<any, any>>) {
	// 	await this.instantiateMenu(event);
		// if (!isForThisProduct) {
		// 	return;
		// }
		// const defaultSKU = app.currentDefaults.carpetImprint;
		// if (defaultSKU) {
		// 	const select = <InputSelect.Component> this.component_find('@:content.options');
		// 	await select.updateValueFromId(defaultSKU);
		// }
	// };

	override async onValueUpdated(ev : STD.events.Event<any, CM.Component<any, any>>) {
		await super.onValueUpdated(ev);
		const select = <InputSelect.Component> this.component_find('@:content.options');
		const option = select.value;
		if (!app.basket || !app.basket.basket.currentProduct) {
			this.component_throwLibraryError('');
		}
		const part = app.basket.basket.currentProduct.getPart([ 'carpetImprint' ]);
		const currentOption = part.currentOption;
		if(currentOption && option && currentOption.id === option.id){
			return;
		}
		if (!option) {
			if (part.currentOption) {
				await part.unuseOption();
			}
		} else {
			await part.useOption(option.id);
		}
	};

	override async component_initialize() {
		// await this.component_find('@:content').component_instantiateOuterChild({
		// 	type :          'input-select',
		// 	isSlot :        false,
		// 	declaredSlot :  null,
		// 	id :            'options',
		// 	slot :          null,
		// 	tree :          this.component_tree,
		// 	parentNode :    null,
		// 	configuration : {}
		// });
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('');
		}
		for (const product of app.basket.basket.products) {
			// TODO : check this product has carpetImprint.
			const part = product.createPart({
				id :        'carpetImprint',
				title :     'Carpet',
				reference : null,
				metaData :  null,
				parts :     [],
				options :   []
			});
			await part.initialize();
		}
	};

	get productComponent() {
		const product = app.currentProduct;
		if (!product || !product.reference) {
			this.component_throwUserError('');
		}
		const productSKU = product.reference.value;
		const PC = app.component_configuration.productsComponents.find(x =>
			(x.type === 'carpetImprint') &&
			x.products.includes(productSKU)
		);
		if (!PC) {
			throw STD.errors.user('No product component with type carpetImprint!');
		}
		return PC;
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingCarpetImprintEditorComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory();
	};
};
export namespace NS {
	export const Component = StandingCarpetImprintEditorComponent;
	export type Component = StandingCarpetImprintEditorComponent;
	export type Configuration = IStandingCarpetImprintEditorComponentConfiguration;
}
import manifestXMLSource              from './StandingCarpetImprintEditor.xml';
import './StandingCarpetImprintEditor.scss';
// import { NS as StandingCarpetTileNS } from '../StandingCarpetImprintTile/StandingCarpetImprintTile';

CM.declare({
	id :       'standing-carpetImprintEditor',
	type :     StandingCarpetImprintEditorComponent,
	manifest : manifestXMLSource
});
